import React from 'react'
import Interview from '../components/Career/interview/Interview'
import { Route, Routes } from 'react-router-dom'
import InterviewReact from '../components/Career/interview/InterviewsTracs/InterviewReact'

const InterviewPage = () => {
    return (
        <div>
            <Interview />
        </div>
    )
}

export default InterviewPage
